import { FC } from 'react';

import { Divider, DividerProps } from '@mui/material';

import styles from './DividerComponent.module.scss';

export const DividerComponent: FC<DividerProps> = (props) => {
  return <Divider className={styles.divider} {...props} />;
};
